import { Component, Input } from '@angular/core';

import { ImageFormatVariantEnum } from '~/attendee/components/shared/section/text-and-blocks/enums/image-format-variant.enum';
import { CmsBlockVariantEnum } from '~/cms/enums/cms-block-variant.enum';
import { TextAndBlockBlockCms } from '~/cms/interfaces/homepage.cms.interface';
import { VtmnPlayButtonShapeEnum } from '~/component/buttons/vtmn-play-button/enum/vtmn-play-button-shape.enum';
import { VtmnPlayButtonVariantEnum } from '~/component/buttons/vtmn-play-button/enum/vtmn-play-button-variant.enum';

@Component({
  selector: 'app-cms-text-and-blocks-block',
  templateUrl: './block.component.html',
  styleUrls: ['./block.component.scss'],
})
export class CmsTextAndBlocksBlockComponent {
  @Input() public block: TextAndBlockBlockCms;
  @Input() public imageFormatVariant = ImageFormatVariantEnum.DEFAULT;
  @Input() public variant: CmsBlockVariantEnum;

  public readonly vtmnPlayButtonVariant = VtmnPlayButtonVariantEnum;
  public readonly vtmnPlayButtonShape = VtmnPlayButtonShapeEnum;

  public get hasIcon(): boolean {
    return this.block.icon && !this.block.image;
  }

  public get hasImage(): boolean {
    return !!this.block.image?.url;
  }

  public get hasLink(): boolean {
    return !!(this.block?.link_label && this.block?.link_url);
  }

  public get iconName(): string {
    return this.block.icon.replace(/_/gi, '-');
  }

  public get imageFormatVariantClass(): string {
    return (
      this.imageFormatVariant === ImageFormatVariantEnum.RECTANGLE &&
      `text-and-blocks-block__picture--${this.imageFormatVariant}`
    );
  }

  public get variantClass(): string {
    return `text-and-blocks-block--${this.variant}`;
  }
}
